import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setSession, clearSession } from '../store/actions/session';

const SessionProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isMountedRef = useRef(true);

  // Fetch session from backend
  const fetchSession = async () => {
    try {
      const res = await fetch('/private/common/web/sessions', {
        credentials: 'include',
      });
      if (!res.ok) throw new Error('No session found');
      const data = await res.json();

      if (isMountedRef.current) {
        // Store only sessionId and expirationTime in Redux
        dispatch(
          setSession({
            sessionId: data.sessionId,
            expirationTime: data.expires,
            state: data.state,
          })
        );
      }
    } catch (err) {
      if (isMountedRef.current) dispatch(clearSession());
    }
  };

  // On mount, fetch session
  useEffect(() => {
    isMountedRef.current = true;
    fetchSession();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return children;
};

export default SessionProvider;
